<template>
  <pt-life-experience-pavilion-table class="pt-hospital-tablee__withData" ref="table" :tableLabels="tableLabels" :tableData="tableData"
   @getTableData="getTableData" :totalNumber="totalNumber">
      <slot/>
  </pt-life-experience-pavilion-table>
</template>

<script>
import PtLifeExperiencePavilionTable from './index'
export default {
  name: 'pt-life-experience-pavilion__withData',
  components: {
    'pt-life-experience-pavilion-table': PtLifeExperiencePavilionTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next) {
      let data = {
        pageable: {
          page: this.page,
          size: this.pageSize
        }
      }
      this.$store.dispatch('getLifeExperienceHallsList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '获取生命体验馆列表失败')
      })
    }

  }
}
</script>
